import normal from './lib/estilos/normal';
import monetario from './lib/estilos/monetario';

const estilos = {
    normal: normal,
    monetario: monetario
}

const porExtenso = (numero, estilo = 'normal') => {
    return estilos[estilo](numero);
}

export default { porExtenso };



// WEBPACK FOOTER //
// ./src/app/shared/helpers/numberToWord/index.ts